import { flatMap, keys, uniq } from 'lodash';
import uuid from 'uuid/v1';
import {
    COMPARISON_OPERATOR,
    ENTITY_TYPE,
    FIELD_NAME,
    LOGICAL_OPERATOR,
    PUSH_API_STATUS,
} from 'modules/push-api/utils/subscriptionConsts';

export const pushApiSubscriptionInitialValues = {
    name: null,
    userId: null,
    entities: [
        {
            id: uuid(),
            type: ENTITY_TYPE.CAMPAIGN,
            endpointUrl: null,
            fetchEntity: false,
            policyId: '1',
            logicalOperator: LOGICAL_OPERATOR.OR,
            status: PUSH_API_STATUS.APPROVED,
            fields: [
                {
                    id: uuid(),
                    name: FIELD_NAME.CAMPAIGN_NAME,
                    logicalOperator: LOGICAL_OPERATOR.OR,
                    filters: [
                        {
                            id: uuid(),
                            newValueCriterion: null,
                            newComparisonOperatorCriterion: COMPARISON_OPERATOR.ALWAYS_TRUE,
                            logicalOperator: LOGICAL_OPERATOR.AND,
                            previousValueCriterion: null,
                            previousComparisonOperatorCriterion: COMPARISON_OPERATOR.ALWAYS_TRUE,
                        },
                    ],
                },
            ],
        },
    ],
};

// Get all keys from each level
export const pushApiSubscriptionKeys = uniq([
    ...keys(pushApiSubscriptionInitialValues),
    ...flatMap(pushApiSubscriptionInitialValues.entities, entity => keys(entity)),
    ...flatMap(pushApiSubscriptionInitialValues.entities, entity => flatMap(entity.fields, field => keys(field))),
    ...flatMap(pushApiSubscriptionInitialValues.entities, entity =>
        flatMap(entity.fields, field => flatMap(field.filters, filter => keys(filter)))
    ),
]);
